import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useToast } from "../utils/useToast";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { NavLink, Outlet } from "react-router-dom";
import { handleLogout as commonLogout } from "../utils/logout";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  CssBaseline,
  Divider,
  CircularProgress,
  Fade,
} from "@mui/material";
import {
  //Dashboard as DashboardIcon,
  BarChart as BarChartIcon,
  Group as UsersIcon,
  SignalCellularAlt as LevelsIcon,
  ViewModule as BatchesIcon,
 // Description as ReportsIcon,
 // Settings as SettingsIcon,
  Logout as LogoutIcon,
  Menu as MenuIcon,
} from "@mui/icons-material";

const navItems = [
 // { to: "/admin/dashboard", label: "Dashboard", icon: <DashboardIcon /> },
  {
    to: "/admin/platform-stats",
    label: "Platform Statistics",
    icon: <BarChartIcon />,
  },
  { to: "/admin/users", label: "Users", icon: <UsersIcon /> },
  { to: "/admin/levels", label: "Levels", icon: <LevelsIcon /> },
  { to: "/admin/batches", label: "Batches", icon: <BatchesIcon /> },
  { to: "/admin/enrollments", label: "Enrollments", icon: <UsersIcon /> },
  {
    to: "/admin/batch-allocation",
    label: "Batch Allocation",
    icon: <BatchesIcon />,
  },
 // { to: "/admin/reports", label: "Reports", icon: <ReportsIcon /> },
 // { to: "/admin/settings", label: "Settings", icon: <SettingsIcon /> }, 
  {
    to: "/admin/config-app-prices",
    label: "Config App Prices",
    icon: <BarChartIcon />,
  },
  {
    to: "/admin/fee-plan-prices",
    label: "Fee Plan Prices",
    icon: <BarChartIcon />,
  },
  { to: "/admin/payments", label: "Payments", icon: <BarChartIcon /> },
];

function handleLogout() {
  commonLogout();
}

const drawerWidth = 240;
const collapsedDrawerWidth = 64;

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [toast] = useToast();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 500); // 0.5s spinner
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        minHeight: { xs: "100svh", sm: "100vh" },
      }}
    >
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: "#000" }}
      >
        <Toolbar sx={{ px: { xs: 1, sm: 2 } }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={() => setSidebarOpen(true)}
            sx={{ mr: 2, display: { sm: "none" }, color: "#000" }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ color: "#fff", flexGrow: 1, fontSize: { xs: 16, sm: 20 } }}
          >
            AKAAL KIDS - Admin Panel
          </Typography>
          {/* Desktop collapse toggle */}
          <IconButton
            color="inherit"
            aria-label={
              sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"
            }
            onClick={() => setSidebarCollapsed((prev) => !prev)}
            sx={{ display: { xs: "none", sm: "inline-flex" } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      {/* Desktop Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          width: sidebarCollapsed ? collapsedDrawerWidth : drawerWidth,
          flexShrink: 0,
          transition: "width 0.2s",
          [`& .MuiDrawer-paper`]: {
            width: sidebarCollapsed ? collapsedDrawerWidth : drawerWidth,
            boxSizing: "border-box",
            display: { xs: "none", sm: "block" },
            transition: "width 0.2s",
            overflowX: "hidden",
          },
        }}
        open
      >
        <Toolbar />
        <Box sx={{ overflow: "auto" }}>
          <NavLink to="/" style={{ textDecoration: "none" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                p: 2,
                justifyContent: sidebarCollapsed ? "center" : "flex-start",
              }}
            >
              <img
                src="/assets/images/logo.png"
                alt="Admin Logo"
                style={{
                  height: 40,
                  marginRight: sidebarCollapsed ? 0 : 8,
                  transition: "margin 0.2s",
                }}
              />
            </Box>
          </NavLink>
          <Divider />
          <List>
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {({ isActive }) => (
                  <ListItem disablePadding>
                    <ListItemButton
                      selected={isActive}
                      sx={{
                        transition: "background 0.2s",
                        "&:hover": {
                          backgroundColor: "rgba(0,0,0,0.08)",
                        },
                        ...(isActive && {
                          backgroundColor: "rgba(25, 118, 210, 0.15)",
                          borderLeft: sidebarCollapsed
                            ? "none"
                            : "4px solid #1976d2",
                        }),
                        pl: sidebarCollapsed ? 1 : 2,
                        justifyContent: sidebarCollapsed
                          ? "center"
                          : "flex-start",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: sidebarCollapsed ? 0 : 2,
                          justifyContent: "center",
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      {!sidebarCollapsed && (
                        <ListItemText primary={item.label} />
                      )}
                    </ListItemButton>
                  </ListItem>
                )}
              </NavLink>
            ))}
            <ListItem disablePadding>
              <ListItemButton
                onClick={handleLogout}
                sx={{
                  transition: "background 0.2s",
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.08)",
                  },
                  pl: sidebarCollapsed ? 1 : 2,
                  justifyContent: sidebarCollapsed ? "center" : "flex-start",
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: sidebarCollapsed ? 0 : 2,
                    justifyContent: "center",
                  }}
                >
                  <LogoutIcon />
                </ListItemIcon>
                {!sidebarCollapsed && <ListItemText primary="Logout" />}
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", sm: "none" },
          [`& .MuiDrawer-paper`]: {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: "auto" }}>
          <NavLink to="/" style={{ textDecoration: "none" }}>
            <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
              <img
                src="/assets/images/logo.png"
                alt="Admin Logo"
                style={{ height: 40, marginRight: 8 }}
              />
            </Box>
          </NavLink>
          <Divider />
          <List>
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                style={{ textDecoration: "none", color: "inherit" }}
                onClick={() => setSidebarOpen(false)}
              >
                {({ isActive }) => (
                  <ListItem disablePadding>
                    <ListItemButton selected={isActive}>
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText primary={item.label} />
                    </ListItemButton>
                  </ListItem>
                )}
              </NavLink>
            ))}
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  setSidebarOpen(false);
                  handleLogout();
                }}
              >
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText primary="Logout" />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          px: { xs: 1, sm: 3 },
          py: { xs: 2, sm: 3 },
          width: "100%",
          alignItems: "flex-start",
          minHeight: { xs: "100svh", sm: "100vh" },
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />
        <Fade in={loading} unmountOnExit>
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              bgcolor: "rgba(255,255,255,0.7)",
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={60} thickness={5} />
          </Box>
        </Fade>
        <Box
          sx={{
            opacity: loading ? 0.5 : 1,
            transition: "opacity 0.2s",
            flex: 1,
            width: "100%",
          }}
        >
          <Outlet />
        </Box>
        {/* Footer */}
        <Box
          component="footer"
          sx={{
            mt: 2,
            py: { xs: 1, sm: 2 },
            textAlign: "center",
            color: "text.secondary",
            fontSize: { xs: 11, sm: 13 },
            width: "100%",
          }}
        >
          © {new Date().getFullYear()} Gurmat Education Platform &mdash; v1.0.0
        </Box>
      </Box>
      <Snackbar
        open={toast.open}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={toast.type} sx={{ width: "100%" }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AdminLayout;
